export default "__VITE_ASSET__jnsqvE80__"